import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eeb30fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card ss-fadein" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ss-div-icone-etapa" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-icone-etapa",
    img: "",
    src: "/static/img/configuracao-inicial/icone-empresa.png"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Revise seus dados", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Informe sua logo e ajuste as informações da usa empresa", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "ant-col ss-div-conteudo"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Informe sua logo e ajuste as informações da usa empresa", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ant-col ss-div-icone-etapa" }
const _hoisted_12 = {
  key: 0,
  class: "ss-icone-etapa ss-fadein",
  img: "",
  src: "/static/img/configuracao-inicial/icone-feito.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_empresa_dados_cadastrais_modal = _resolveComponent("empresa-dados-cadastrais-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.props.configuracao.etapaAtual == _ctx.EEtapaConfiguracaoInicial.Empresa)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirEmpresa && _ctx.abrirEmpresa(...args)))
            }, _hoisted_7)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.computedConfiguracao.etapaAtual !== _ctx.EEtapaConfiguracaoInicial.Empresa)
          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ss-botao-concluir",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.concluir && _ctx.concluir(...args)))
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Concluir!")
                ]),
                _: 1
              }, 8, ["spinning"])
            ]))
      ])
    ]),
    _createVNode(_component_empresa_dados_cadastrais_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirDados,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirDados) = $event))
    }, null, 8, ["operacao", "visivel"])
  ]))
}